<template lang="pug">
    .test-result-container(ref='testResultContainer')
        .summary
            v-btn(@click='printReport()') Imprimir Reporte
            v-container(v-if='ss')
                a(download :href='ss') Descargar Reporte
            v-card.summ-card-a
                v-card-title Resultados
                v-card-text.summary-info
                    v-row
                        v-row
                            v-col.best-rates
                                v-col
                                    .spark-box.note.grades Calificación Promedio
                                        br
                                        br 
                                        | {{ total_rate | rounded }} %
            v-card.filters-container
              v-card-title Filtros
              v-card-text
                v-row
                  v-text-field.search-field(v-model='search' append-icon='search' label='Search' single-line='' hide-details='')
                v-row
                  v-col(cols='12' sm='6' md='4')
                    v-row
                      v-col
                        v-radio-group(v-model='selectFilter' row)
                          v-radio( :label='`Filtrar por Grupo`' :value='1')
                          v-radio( :label='`Filtrar por Examen`' :value='2')

                  v-col(v-if='selectFilter == 1' cols='12' sm='6' md='4')
                      v-select(:items='groups' :multiple='true' item-text='name' item-value='id' v-model='filters.groups' label='Grupo' :return-object='true' @change='getEvaluations' )
                  v-col(v-if='selectFilter == 2' cols='12' sm='6' md='4')
                      v-select(:items='exams' :multiple='true' item-text='name' item-value='id' v-model='filters.exams' label='Examenes' :return-object='true' @change='getEvaluations' )
                  //- v-col(cols='12' sm='6' md='4')
                  //-     v-select(:items='groups' :multiple='true' item-text='name' item-value='id' v-model='filters.groups' label='Instituto' :return-object='true' )
            v-card.table_results
                v-card-title Tabla General
                v-card-text.results-summ-table
                    v-data-table.elevation-1(:headers='headers' :items='evaluation_results' :search="search" )
                        template(v-slot:item.lvl='{ item }')
                            | {{ proxLvl( item.total_rate ) }}
                        template(v-slot:item.total_rate='{ item }')
                            | {{ item.total_rate | rounded}} %
                        template(v-slot:item.action='{ item }')
                            v-icon.mr-2(small='' @click='showEvaluation(item)')
                                | open_in_new
                        template(v-slot:item.review='{ item }')
                            v-icon.mr-2(small='' @click='reviewExam(item)')
                                | check
                            
        .reulsts-graphs
            v-card.lvl-graphs-card 
                v-card-title Graficos
                v-card-text
                    template(v-if='loadCharts')
                        apex-chart(type='bar' height='350' :options='lvl_ChartOptions' :series='lvl_rates')
        .results-table(v-if='reportOn')
            v-card
                v-card-title Tabla de resultados
                v-card-text
                    v-data-table.elevation-1(:headers='headers_c' :items='table_cat_results')
                        template(v-slot:item.rate='{ item }')
                            v-chip(:color='getColor(item.rate)' dark='') {{ item.rate | rounded}} %
                        template(v-slot:item.bar='{ item }')
                            v-progress-linear(v-model='item.rate' :color='getColor(item.rate)' height='25' reactive='')        


</template>

<script>
import { config } from '../config.js'

export default {
     data: () => ({
        loadCharts: false,
        reportOn:false,
        selectFilter: 0,
        ss:'',
        search:'',
        default_uri:'',
        user: '',
        eval_id:'',
        evaluation:'',
        total_rate: '',
        total_hits: '',
        best_lvl:'',
        worst_lvl:'',
        best_cat:'',
        worst_cat:'',
        agg: false,
        type_opt: '',
        filter_evals:'',
        filters: {
          groups: [],
          exams: []
        },
        lvl_results:{},
        table_cat_results: [],
        table_lvl_results: [],
        lvl_rates: [{
          name: 'Porcentaje',
          data: []
        },
        {
          name: 'Sin responder',
          data: []
        }],
        headers_c: [
            { text: 'Categoría', value: 'cat', sortable: true },
            { text: 'Porcentaje', value: 'rate', sortable: true },
            { text: 'Avance', value: 'bar', sortable: true },
            { text: 'Aciertos', value: 'hits', sortable: true },
            { text: 'Sin responder', value: 'unres', sortable: true },
        ],
        groups: [],
        exams: [],
        lvl_rates: [{
          name: 'Porcentaje',
          data: []
        }],
        series: [75],
        headers: [
            { text: 'Id del Examen', value: 'exam_id', sortable: false },
            { text: 'Fecha de evaluación', value: 'createDate', sortable: true },
            { text: 'Nivel', value: 'lvl', sortable: true },
            { text: 'Total', value: 'total_rate', sortable: true },
            { text: 'Aciertos', value: 'totals', sortable: true },
            { text: 'Nombre', value: 'student.name', sortable: true},
            { text: 'Apellido', value: 'student.lastName', sortable: true},
            { text: 'Reporte', value: 'action', sortable: false },
            { text: 'Revision', value: 'review', sortable: false }
        ],
        evaluation_results: [],
        lvl_ChartOptions: {
          chart: {
            height: 350,
            type: 'bar',
            toolbar: {
              show: false
            }
          },
          plotOptions: {
            bar: {
              dataLabels: {
                position: 'center',
              }
            }
          },
          colors: [function({ value, seriesIndex, w }) {
            if( value > 70){
                return '#1CC716';
            }else if( value > 50 && value <= 70 ){
                return '#EED221';
            }else if( value <= 50){
                return '#EE2121';
            }
          }],
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return Math.round(val) + "%";
            },
            offsetY: -20,
            style: {
              fontSize: '1.5rem',
              colors: ["white"]
            }
          },
          xaxis: {
            categories: [],
            position: 'top',
            labels: {
              offsetY: -18,
              style: {
                    fontSize: '1.2rem',
                }
            },
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false
            },
            tooltip: {
              enabled: true,
              offsetY: -35,
            }
          },
          fill: {
            gradient: {
              shade: 'light',
              type: "horizontal",
              shadeIntensity: 0.25,
              gradientToColors: undefined,
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [50, 0, 100, 100]
            },
          },
          yaxis: {
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false,
            },
            labels: {
              show: false,
              formatter: function (val) {
                return val.toFixed(2) + "%";
              }
            }

          },
          title: {
            text: 'Resultados por nivel',
            floating: true,
            offsetY: 320,
            align: 'center',
            style: {
              color: '#444',
              fontSize: '1.2rem'
            }
          }
        },
        chartOptions: {
          chart: {
            toolbar: {
              show: false
            }
          },
          plotOptions: {
            radialBar: {
              startAngle: -135,
              endAngle: 225,
              hollow: {
                margin: 0,
                size: '75%',
                background: '#fff',
                position: 'front',
                dropShadow: {
                  enabled: true,
                  top: 3,
                  left: 0,
                  blur: 4,
                  opacity: 0.24
                }
              },
              track: {
                background: '#fff',
                strokeWidth: '50%',
                margin: 0, // margin is in pixels
                dropShadow: {
                  enabled: true,
                  top: -3,
                  left: 0,
                  blur: 4,
                  opacity: 0.35
                }
              },

              dataLabels: {
                name: {
                  offsetY: -10,
                  show: false,
                  color: '#888',
                  fontSize: '17px'
                },
                value: {
                  formatter: function (val) {
                    return parseInt(val) + '%';
                  },
                  color: '#111',
                  fontSize: '36px',
                  show: true,
                }
              }
            }
          },
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'dark',
              type: 'horizontal',
              shadeIntensity: 0.5,
              gradientToColors: ['#ABE5A1'],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100]
            }
          },
          stroke: {
            lineCap: 'round'
          },
          labels: [' '],
        }
    }),
    created(){
        this.$emit("loadingEvent", true);
        this.user = JSON.parse(localStorage.getItem('user'));
        if(this.user.admin || this.user.inst || this.user.type == 'Profesor'){
            this.agg = true;
            this.type_opt = this.user.admin ? 'all' : 'inst';
            this.type_opt = this.user.type == 'Profesor' ? 'prof' : this.type_opt;
            this.initialize();
            
        }else{
            this.$emit("loadingEvent", false);
            this.$router.push({ name: 'home' });
        }
        
    },
    mounted(){
    },
    methods:{
        initialize(){

            let url, filters_cats = '';
            
            if(this.type_opt == 'inst' && this.user.inst){
                url = `${config.serviceUri}evaluations?type=${this.type_opt}&agg=${this.agg}&filter={"id_inst":"${this.user.id}"}`
            }else if(this.type_opt == 'prof'){
                let asc_groups = this.user.asoc_groups.map(g => g.id);
                let asc_groups_name = this.user.asoc_groups.map(g => g.name);
                url = `${config.serviceUri}evaluations?type=${this.type_opt}&agg=${this.agg}&filter={"student.groups_ids":${JSON.stringify(asc_groups)}}`
                filters_cats = `&filter={"__array__name":${JSON.stringify(asc_groups_name)}}`;
            }else{
                url = `${config.serviceUri}evaluations?type=${this.type_opt}&agg=${this.agg}`
            }
            
            this.default_uri = url;
            this.axios.get(url)
            .then( (response) => {
            
                let order = {};
                console.log('Succes request: ',response.data);
                this.evaluation = response.data.payload;

                let degLvl = this.evaluation.degLvl.sort(function (a, b) {
                            if (a.lvl > b.lvl) {
                              return 1;
                            }
                            if (a.lvl < b.lvl) {
                              return -1;
                            }
                            return 0;
                          });
                          
                degLvl.forEach( lvl => {
                    this.lvl_rates[0].data.push(lvl.rate);
                    this.lvl_ChartOptions.xaxis.categories.push(lvl.lvl);
                })

                let catRes = this.evaluation.evaluations.map( e => e.byCat.results);
                this.getCatResults(catRes);

                this.table_lvl_results = this.evaluation.degLvl;
                this.total_rate = this.evaluation.prom_rate;
                this.best_lvl = this.evaluation.prom_best_lvl;
                this.worst_lvl = this.evaluation.prom_worst_lvl;
                this.best_cat = this.evaluation.prom_best_cat;
                this.worst_cat = this.evaluation.prom_worst_cat;
                this.evaluation_results = this.evaluation.evaluations;
                this.loadCharts = true;
                this.$emit("loadingEvent", false);
            })
            .catch( (error) => {
                console.log('Error: ', error);
                this.$emit("loadingEvent", false);
                this.$router.push({ name: 'home' });
            });

            this.axios.get(`${config.serviceUri}catalogs?catalog=groups${filters_cats}`)
            .then( (response) => {
                console.log('Succes request: ',response.data);
                this.groups = response.data.payload.sort(function (a, b) {
                                if (a.name > b.name) {
                                  return 1;
                                }
                                if (a.name < b.name) {
                                  return -1;
                                }
                                return 0;
                              });
                this.$emit("loadingEvent", false);
            })
            .catch( (error) => {
                console.log('Error: ', error);
                this.$emit("loadingEvent", false);
            });

            this.axios.get(`${config.serviceUri}catalogs?catalog=exams`)
            .then( (response) => {
                console.log('Succes request: ',response.data);
                this.exams = response.data.payload.sort(function (a, b) {
                                if (a.name > b.name) {
                                  return 1;
                                }
                                if (a.name < b.name) {
                                  return -1;
                                }
                                return 0;
                              });
                this.$emit("loadingEvent", false);
            })
            .catch( (error) => {
                console.log('Error: ', error);
                this.$emit("loadingEvent", false);
            });

            
        },
        proxLvl(rate){
            rate = Number(Number.parseFloat(rate).toFixed(2));
            console.log(rate);
            
            if(rate >= 0 && rate <= 17.66){
                return 'A1'
            }else if(rate >= 17.67 && rate <= 34.33){
                return 'A2'
            }else if(rate >= 34.34 && rate <= 42.66){
                return 'B1-'
            }else if(rate >= 42.67 && rate <= 51.66){
                return 'B1'
            }else if(rate >= 51.67 && rate <= 59.33){
                return 'B1+'
            }else if(rate >= 59.34 && rate <= 67.66){
                return 'B2-'
            }else if(rate >= 67.67 && rate <= 76.66){
                return 'B2'
            }else if(rate >= 76.67 && rate <= 84.33){
                return 'B2+'
            }else if(rate >= 84.34 && rate <= 100){
                return 'C1'
            }
        },
        getEvaluations(){
          let url;
          if(this.selectFilter == 1){
            this.filters.exams = [];
          }else if(this.selectFilter == 2){
            this.filters.groups = [];
          }

          if(this.filters.groups.length == 0 && this.filters.exams == 0){
            url = this.default_uri;
          }else{
            if(this.filters.exams.length > 0 && this.filters.groups.length == 0){
              let _exams = this.filters.exams.map( e => e.id);
              url = `${config.serviceUri}evaluations?type=${this.type_opt}&agg=${this.agg}&filter={ "__array__exam_id": ${JSON.stringify(_exams)} }`
            }else if(this.filters.exams.length == 0 && this.filters.groups.length > 0){
              let _groups = this.filters.groups.map( g => g.id);
              url = `${config.serviceUri}evaluations?type=${this.type_opt}&agg=${this.agg}&filter={ "student.groups_ids":${JSON.stringify(_groups)}}`
            }
          }
          
          this.$emit("loadingEvent", true);
          this.axios.get(url)
            .then( (response) => {
                if(response.status == 204){
                  this.$emit("loadingEvent", false);
                  return;
                }
                let order = {};
                console.log('Succes request: ',response.data);
                this.evaluation = response.data.payload;

                let degLvl = this.evaluation.degLvl.sort(function (a, b) {
                            if (a.lvl > b.lvl) {
                              return 1;
                            }
                            if (a.lvl < b.lvl) {
                              return -1;
                            }
                            return 0;
                          });
                          
                degLvl.forEach( lvl => {
                    this.lvl_rates[0].data.push(lvl.rate);
                    this.lvl_ChartOptions.xaxis.categories.push(lvl.lvl);
                })

                let catRes = this.evaluation.evaluations.map( e => e.byCat.results);
                this.getCatResults(catRes);

                this.table_lvl_results = this.evaluation.degLvl;
                this.total_rate = this.evaluation.prom_rate;
                this.best_lvl = this.evaluation.prom_best_lvl;
                this.worst_lvl = this.evaluation.prom_worst_lvl;
                this.best_cat = this.evaluation.prom_best_cat;
                this.worst_cat = this.evaluation.prom_worst_cat;
                this.evaluation_results = this.evaluation.evaluations;
                this.loadCharts = true;
                this.$emit("loadingEvent", false);
            })
            .catch( (error) => {
                console.log('Error: ', error);
                this.$emit("loadingEvent", false);
                this.$router.push({ name: 'home' });
            });
        },
        getLvlResults(lvlResults){
          if( lvlResults && lvlResults.length > 0 ){
            
            let order = {};
            lvlResults.forEach( lvl_results => {
              Object.keys(lvl_results).sort().forEach(function(key) {
                order[key] = lvl_results[key];
              });
            })

            let _this = this;
            Object.keys(order).forEach( l => {
                let lvl_t = {};

                lvl_t = {
                    lvl: l,
                    rate: order[l].rate,
                    hits: `${order[l].correct} / ${order[l].total}`,
                    unres: order[l].unresponsed
                }

                _this.table_lvl_results.push(lvl_t);
                _this.lvl_rates[0].data.push(lvl_t.rate);
                _this.lvl_rates[1].data.push(lvl_t.unres);
                
            })
          }
        },
        getCatResults(catResults){
          if( catResults && catResults.length > 0 ){
            this.table_cat_results = [];
            let order_c = {};
            catResults.forEach( cat_results => {
              Object.keys(cat_results).sort().forEach(function(key) {
                if(order_c[key]){
                  order_c[key].unresponsed += cat_results[key].unresponsed;
                  order_c[key].total += cat_results[key].total;
                  order_c[key].correct += cat_results[key].correct;
                  order_c[key].rate += cat_results[key].rate;
                }else{
                  order_c[key] = cat_results[key]; 
                }
              });
            })

            let _this = this;
            Object.keys(order_c).forEach( c => {
              let cat_t = {}, rate_calc;

              rate_calc = (order_c[c].correct * 100) / order_c[c].total;

              cat_t = {
                  cat: c,
                  rate: rate_calc,
                  hits: `${order_c[c].correct} / ${order_c[c].total}`,
                  unres: order_c[c].unresponsed
              }

              _this.table_cat_results.push(cat_t);
            })
          }
        },
        statusClass(rate){
            rate = Number(rate);
            if( rate > 70){
                return { 'hit-success' : true }
            }else if( rate > 50 && rate <= 70 ){
                return { 'hit-warning' : true }
            }else if( rate <= 50){
                return { 'hit-error' : true }
            }
        },
        printReport(){
            let _this = this
            const el = this.$refs.testResultContainer;
            const options = {
                type: 'dataURL'
            }

            this.$html2canvas(el, options).then((e) =>{
                _this.ss = e;
            });
            // this.$htmlToPaper('testResultContainer');
        },
        showEvaluation(item){
            console.log(item);
            this.$router.push({ name: 'indiv-results', query: { id: item.id } });
        },
        reviewExam(item){
            console.log(item);
            this.$router.push({ name: 'checkLanTest', query: { id: item.id } });
        },
        getColor (rate) {
            rate = Number(rate);
            if( rate > 70){
                return 'green';
            }else if( rate > 50 && rate <= 70 ){
                return 'yellow';
            }else if( rate <= 50){
                return 'red';
            }
        },
    }
}
</script>

<style scoped>

.v-card{
    border: none !important;
    -webkit-box-shadow: 0px 10px 8px 2px rgba(0,0,0,0.15);
    -moz-box-shadow: 0px 10px 8px 2px rgba(0,0,0,0.15);
    box-shadow: 0px 10px 8px 2px rgba(0,0,0,0.15);
}
.summary-info{
    font-size: 1.25rem;
}

.summary{
    margin: 15px;
}

.summary .v-card{
    margin: 15px;
}
.lvl-result{
    display: flex;
    flex-wrap: wrap;
    flex-direction: row !important;

}
.reulsts-graphs{
    margin: 15px;
    display: flex;
}
.results-table{
    margin: 15px;
    display: flex;
}

.results-table .v-card{
    margin: 15px;
    flex: 1;
}

.lvl-graphs-card{
    flex: 1;
}
.reulsts-graphs .v-card{
    margin: 15px;
}

.summ-card{
    margin: 15px;
}
.lvl-card{
    flex: 1 1 250px;
    margin: 15px 15px;
}

.levl-box{
    flex: 1 1;


    display: flex;
    justify-content: center;
}

.spark-box{
    display: flex;
    background: rgb(2,0,36);
    background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(46,46,173,1) 35%, rgba(0,212,255,1) 100%);
    border-radius: 15px;
    padding: 10px;
    min-width: 150px;
    max-width: 200px;
    min-height: 150px;
    color: wheat;

    align-items: center;
    justify-content: center;
    font-size: 2.5rem;

}

.best-rates{
    display: flex;
    flex-direction: row;

    flex-wrap: wrap;
}
.spark-box.note{
    flex: 1 1 220px;

    color: aliceblue;
    font-size: 1.4rem;
    text-align: center;
    font-weight: 500;
}
.spark-box.note.good{
    background: #23CDA1;
}

.spark-box.spark-box.note.bad{
    background: #747575;
}

.spark-box.spark-box.note.grades{
    background: #1CC5CB;
}

.levl-box .spark-box{
    background: #3E84DE !important;
}

.hit{
    background-color: none !important;
    font-size: 1.5rem;
    text-align: center;
    color: #363636 ;
}

.search-field{
    margin: auto 1%;
}

</style>
